import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highcharts3d from 'highcharts/highcharts-3d';
import exporting from 'highcharts/modules/exporting';

// Initialize exporting and 3D modules
exporting(Highcharts);
highcharts3d(Highcharts);

const ServiceUtilizationRatePie = () => {
  // Example data based on the formula provided
  const numberOfUtilizedServices = 70; // Replace with actual data
  const totalServicesAssigned = 100; // Replace with actual data

  // Calculate utilization rate
  const utilizationRate = (numberOfUtilizedServices / totalServicesAssigned) * 100;
  const nonUtilizedRate = 100 - utilizationRate;

  // Pie chart data for service utilization rate
  const pieData = [
    {
      name: 'Utilized Services',
      y: utilizationRate,
      color: '#008000' // Green
    },
    {
      name: 'Non-Utilized Services',
      y: nonUtilizedRate,
      color: '#FF0000' // Red
    }
  ];

  const pieOptions = {
    chart: {
      type: 'pie',
      height: 220,
      spacing: [0, 0, 0, 0],
      options3d: {
        enabled: true,
        alpha: 70,
        beta: 0
      },
    },
    title: {
      text: null,
      align: 'left',
      style: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#333',
        fontFamily: "IBM Plex Sans, sans-serif",
        marginBottom: '10px'
      }
    },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 30,
        size: 190,
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{point.percentage:.1f}%',
          distance: 5, // Adjust label position
          alignTo: 'toPlotEdges' // Center the label inside the pie slice
        },
        showInLegend: true
      }
    },
    series: [{
      name: 'Service Status',
      data: pieData
    }],
    credits: {
      enabled: false
    },
    exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              enabled: false
            }
          }
        },
    legend: {
      enabled: true
    }
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={pieOptions}
      />
    </div>
  );
};

export default ServiceUtilizationRatePie;
